/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["AVAILABLE"] = "Available";
    AvailabilityStatus["UNAVAILABLE"] = "Unavailable";
})(AvailabilityStatus || (AvailabilityStatus = {}));
